import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import AccountPopover from './AccountPopover';
import DatabaseSwitcher from './DatabaseSwitcher';


function bgBlur(props) {
  const color = props?.color || '#000000';
  const blur = props?.blur || 6;
  const opacity = props?.opacity || 0.8;
  const imgUrl = props?.imgUrl;

  if (imgUrl) {
    return {
      position: 'relative',
      backgroundImage: `url(${imgUrl})`,
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 9,
        content: '""',
        width: '100%',
        height: '100%',
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        backgroundColor: alpha(color, opacity),
      },
    };
  }

  return {
    backdropFilter: `blur(${blur}px)`,
    WebkitBackdropFilter: `blur(${blur}px)`,
    backgroundColor: alpha(color, opacity),
  };
}

const Header = ({ onMenuClick, isMobile }) => {
    const theme = useTheme();

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: 'auto',
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({ color: theme.palette.background.default }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
            }}
        >
            <Toolbar sx={{ height: 1, px: { xs: 2, md: 5 } }}>
                {isMobile && (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={onMenuClick}
                        sx={{ mr: 2, color: 'text.primary' }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <Box sx={{ flexGrow: 1 }} />
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DatabaseSwitcher />
                    <AccountPopover />
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
